/*
 * Pawsly colour grouping for the product gallery.
 *
 * Shopify allows only ONE featured image per variant, but each colourway here has
 * several photos, so gallery media is grouped by the colour named in its ALT TEXT
 * ("Dog People Club Sweatshirt in Sand, front view"). Media that names no colour
 * - the mug, for instance - shows under every selection.
 *
 * product-media-gallery-content.liquid does this server-side, but only on the
 * branch where the selected variant has a featured image. When a shopper picks an
 * option combination that does not exist (Printify has no Sport Grey in S, L or
 * 3XL, and Sand stops at 2XL on the tees) there is no selected variant media, the
 * server falls through to the unfiltered list, and every colour appears at once.
 *
 * Section rendering morphs the new gallery into the page WITHOUT executing inline
 * scripts, so this has to be a persistent listener rather than a one-shot script.
 *
 * Gotcha for future colours: where one colour name contains another ("Blue" /
 * "Light Blue"), the LAST match wins, so list the longer name later.
 */
(function () {
  if (window.__pawslyColourFilter) return;
  window.__pawslyColourFilter = true;

  var busy = false;
  var timer = null;

  function colourFieldset(root) {
    var sets = root.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      var text = legend ? legend.textContent.trim().toLowerCase() : '';
      if (text.indexOf('color') === 0 || text.indexOf('colour') === 0) return sets[i];
    }
    return null;
  }

  function colourOf(alt, colours) {
    var found = '';
    for (var i = 0; i < colours.length; i++) {
      if (alt && colours[i] && alt.indexOf(colours[i]) !== -1) found = colours[i];
    }
    return found;
  }

  function filterGallery(gallery, colours, selected) {
    function offColour(el) {
      var img = el.querySelector('img');
      var alt = img ? img.getAttribute('alt') || '' : '';
      var c = colourOf(alt, colours);
      return c !== '' && c !== selected;
    }

    var groups = [
      'slideshow-slide',
      '.media-gallery__grid > li',
      '.dialog-zoomed-gallery > li',
      '.dialog-thumbnails-list__thumbnail',
      '.slideshow-controls__thumbnail'
    ];

    var removed = false;

    groups.forEach(function (selector) {
      var nodes = Array.prototype.slice.call(gallery.querySelectorAll(selector));
      if (!nodes.length) return;
      // Never empty a group - if nothing matches, leave it rather than show a blank gallery.
      var keep = nodes.filter(function (n) { return !offColour(n); });
      if (!keep.length) return;
      nodes.forEach(function (n) {
        if (offColour(n)) {
          n.remove();
          removed = true;
        }
      });
    });

    if (!removed) return false;

    // Keep pagination, arrows and the counter in step with what is left.
    var slides = gallery.querySelectorAll('slideshow-slide');
    Array.prototype.forEach.call(slides, function (slide, i) {
      if (slide.hasAttribute('index')) slide.setAttribute('index', String(i));
      if (slide.dataset && typeof slide.dataset.index !== 'undefined') slide.dataset.index = String(i);
    });
    Array.prototype.forEach.call(gallery.querySelectorAll('slideshow-controls'), function (c) {
      if (c.hasAttribute('item-count')) c.setAttribute('item-count', String(slides.length));
    });
    var total = gallery.querySelector('.slideshow-controls__counter-total');
    if (total) total.textContent = String(slides.length);

    return true;
  }

  function apply() {
    if (busy) return;
    busy = true;
    try {
      var galleries = document.querySelectorAll('media-gallery');
      if (!galleries.length) return;

      var changed = false;
      Array.prototype.forEach.call(galleries, function (gallery) {
        var scope = gallery.closest('.shopify-section') || document;
        var set = colourFieldset(scope) || colourFieldset(document);
        if (!set) return;

        var inputs = set.querySelectorAll('input[type="radio"]');
        if (inputs.length < 2) return;

        var colours = [];
        var selected = '';
        Array.prototype.forEach.call(inputs, function (input) {
          if (input.value) colours.push(input.value);
          if (input.checked) selected = input.value;
        });
        if (!selected || colours.length < 2) return;

        if (filterGallery(gallery, colours, selected)) changed = true;
      });

      if (changed) window.dispatchEvent(new Event('resize'));
    } catch (e) {
      /* never let this break the page */
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 80);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.tagName === 'INPUT') schedule();
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) schedule();
  }, true);

  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      if (!busy) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
